import { ClickAwayListener, Grid } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Cookies from "js-cookie";
import Link from "next/link";
import { useEffect, useState } from "react";
import { InView } from "react-intersection-observer";
import { useDispatch } from "react-redux";
import Color from "../../../../assets/colors";
import { sendTrackingEvent } from "../../../../helpers/tracking_management";
import { updateShowStickyApply } from "../../../../redux/actions/navbar_action";
import {
  CompanyNameRow,
  CompanyVerifiedBadge,
} from "../../AccordionJobCard/styles";
import JobDetailsJobAlert from "../../JobDetailsJobAlert/JobDetailsJobAlert";
import SingleJobApplyButtonGroup from "../SingleJobApplyButtonGroup/SingleJobApplyButtonGroup";
import SingleJobHighlight from "../SingleJobHighlight/SingleJobHighlight";
import {
  DivStyled,
  ImageStyled,
  InfoCirleFilledStyled,
  NextLinkStyled,
  StyledTooltip,
  StyledTooltipText,
  TooltipInfoText,
  TypographyStyled,
} from "./styles";

function SingleJobTitleSection(props) {
  let companyLogo = props.job?.company
    ? props.job?.company.logo
      ? `https:${props.job?.company.logo}`
      : ""
    : "";

  const [tooltipOpen, setTooltipOpen] = useState(false);

  const belowLg = useMediaQuery("(max-width: 1279px)");
  const belowTablet = useMediaQuery("(max-width: 767px)");

  const [showButton, setShowButton] = useState(false);

  const dispatch = useDispatch();

  function handleShowStickyBottomApplyButton(inViewBool) {
    dispatch(updateShowStickyApply(inViewBool));
  }

  useEffect(() => {
    setShowButton(true);
  }, [props?.job?.id]);

  function TooltipChip() {
    return (
      <ClickAwayListener
        onClickAway={() => {
          setTooltipOpen(false);
        }}
      >
        <StyledTooltip
          open={tooltipOpen}
          onClick={() => {
            setTooltipOpen(true);
          }}
          onMouseEnter={() => {
            setTooltipOpen(true);
          }}
          onClose={() => {
            setTooltipOpen(false);
          }}
          componentsProps={{
            tooltip: {
              sx: {
                display: "flex",
                width: "234px",
                padding: "10px 14px",
                flexDirection: "column",
                alignItems: "center",
                borderRadius: "12px",
                border: "2px solid #222222",
                background: "#FFF",
              },
            },
          }}
          sx={{
            display: "flex !important",
            gap: "4px",
          }}
          title={
            <TooltipInfoText>
              {props.job?.company?.name} is a{" "}
              <span style={{ fontWeight: 700 }}>headhunting firm</span>, the job
              openings listed here are posted on behalf of our clients
            </TooltipInfoText>
          }
          placement="bottom-start"
        >
          <StyledTooltipText>RECRUITMENT firm</StyledTooltipText>
          <InfoCirleFilledStyled />
        </StyledTooltip>
      </ClickAwayListener>
    );
  }

  const isCompanyVerified =
    props.job?.company?.verified === true ||
    props.job?.company?.name === "Hiredly" ||
    props.job?.company?.name === "Hiredly X";

  return (
    <DivStyled
      container
      justifyContent={"space-between"}
      alignItems={"flex-start"}
    >
      <DivStyled
        item
        container
        marginBottom={"16px"}
        xs={12}
        tablet={props?.job?.category === "aggregated" ? 7 : 12}
        md={10}
        lg={12}
      >
        <DivStyled
          xs={12}
          lg={10}
          item
          container
          alignItems={"center"}
          flexWrap={"nowrap"}
          sx={{ marginBottom: belowLg ? "16px" : 0 }}
        >
          {companyLogo ? (
            <ImageStyled
              src={companyLogo}
              width={70}
              height={70}
              alt="company-logo-image"
              style={{
                objectFit: "contain",
                boxShadow: "5px 5px 10px #cecece, -5px -5px 10px #efefef",
                marginBottom: "15px",
              }}
              draggable={false}
            />
          ) : null}

          <DivStyled width={belowLg ? "100%" : "calc(100% - 150px)"}>
            <Link
              href={props.handleHref("jobTitle", props?.job)}
              style={{ textDecoration: "none", color: "currentcolor" }}
            >
              <TypographyStyled
                variant="h1"
                sx={{
                  fontSize: belowTablet ? "17px" : "25px",
                  fontWeight: "bold",
                  marginBottom: "5px",
                  overflowWrap: "anywhere",
                  width: "100%",
                }}
                aria-label="job-title"
              >
                {props?.job?.title}
              </TypographyStyled>
            </Link>
            <Grid
              display={"flex"}
              gap={"8px"}
              alignItems={"flex-start"}
              alignSelf={"stretch"}
              sx={{ minWidth: 0 }}
            >
              {props?.job?.category === "aggregated" ? (
                <Link
                  href={props.handleHref("jobTitle", props?.job)}
                  style={{ textDecoration: "none", color: "currentcolor" }}
                >
                  <TypographyStyled
                    variant="subtitle1"
                    sx={{
                      fontSize: belowTablet ? "14px" : "16px",
                      color: Color.hiredlyPurple,
                      lineHeight: "22px",
                    }}
                    aria-label="company-name"
                  >
                    {props?.job?.aggregatedCompanyName}
                  </TypographyStyled>
                </Link>
              ) : (
                <CompanyNameRow
                  sx={{
                    flex: "1 1 auto",
                    minWidth: 0,
                    maxWidth: "100%",
                    overflow: "hidden",
                  }}
                >
                  <NextLinkStyled
                    href={`/companies/${props.job?.company?.slug}`}
                    aria-disabled={props.job?.company?.hide ? true : false}
                    onClick={() => {
                      Cookies.set("click-source", "job_detail_company_profile");
                      sendTrackingEvent({
                        event: "CE_click-company-ijp",
                        "company-id": props.job?.company?.id,
                        "job-id": props.job?.id,
                      });
                    }}
                    sx={{ minWidth: 0, maxWidth: "100%" }}
                  >
                    <TypographyStyled
                      variant="subtitle1"
                      sx={{
                        fontSize: belowTablet ? "14px" : "16px",
                        color: props.job?.company?.hide
                          ? Color.black
                          : Color.hiredlyPurple,
                        lineHeight: "22px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        flex: "0 1 auto",
                        minWidth: 0,
                        display: "block",
                        "@media (max-width: 640px)": {
                          display: "-webkit-box",
                          WebkitLineClamp: "2",
                          WebkitBoxOrient: "vertical",
                          overflowWrap: "anywhere",
                          wordBreak: "break-word",
                          whiteSpace: "wrap",
                        },
                      }}
                      aria-label="company-name"
                    >
                      {props.job?.company?.name}
                    </TypographyStyled>
                  </NextLinkStyled>
                  {isCompanyVerified && (
                    <CompanyVerifiedBadge aria-label="Verified company" />
                  )}
                  {props.job?.company?.recruitmentFirm && <TooltipChip />}
                </CompanyNameRow>
              )}
            </Grid>
          </DivStyled>
        </DivStyled>
        <DivStyled
          xs={12}
          md={12}
          lg={2}
          item
          container
          justifyContent={belowLg ? "flex-start" : "flex-end"}
          alignItems={"center"}
          columnGap={3}
        >
          {showButton &&
          (belowLg || belowTablet || (!belowLg && !belowTablet)) ? (
            <InView
              trackVisibility={true}
              threshold={0.8}
              delay={300}
              // if this button is not visible, then the sticky apply button should show
              onChange={(inView) => handleShowStickyBottomApplyButton(!inView)}
              style={{
                width: belowTablet ? "100%" : null,
              }}
            >
              <SingleJobApplyButtonGroup job={props.job} />
            </InView>
          ) : null}
        </DivStyled>
      </DivStyled>
      {props?.job?.category === "aggregated" && belowLg && !belowTablet ? (
        <DivStyled item xs={12} tablet={5} md={4} rowGap={"15px"}>
          <SingleJobHighlight job={props.job} />
          <JobDetailsJobAlert job={props.job} />
        </DivStyled>
      ) : null}
    </DivStyled>
  );
}

export default SingleJobTitleSection;
